export default __webpack_public_path__ + "static/media/vck.693fc58d.png";